import ConferenceStatus from "./conferenceStatus";

export default {
    name: 'ConferenceStatusFeature',

    components: {ConferenceStatus}
}